<template>
  <div class="wrapper">

    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            
            <div slot="header">
             
              <i class="fa fa-search-plus 
              "></i><strong> Trazabilidad </strong>
              <div class="card-header-actions">
                  <small class="text-muted">-</small>
              </div>
            </div>
   
             <div class="text-left" @click="goBack"> <b-link>Atras</b-link></div>
            <div class="text-right" > <b-link to="/trazabilidad/search">Buscar nuevo pallet</b-link></div>
                 <br/>
              <h1>Trazabilidad pallet ({{PalletNumber}})</h1>
                 <br/>

             <!-- verificar Recepcion -->

            <div class="text-left" v-if="itemsReception != ''">

                <h2>Recepción</h2>
                <b-table
                striped
                hover
                small
                :items="itemsReception"
                :fields="fieldsReception">

                <template v-slot:cell(Fecha_Creacion)="data">
                {{data.item.Fecha | moment}}
                </template>

                <template v-slot:cell(Guia)="data">
                  <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeGuideDetail(data.item.waybill_id,data.item.Guia)"
                        
                    >{{data.item.Guia}}</a>
                
                </template>

                 <template v-slot:cell(Acciones)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Reporte guia de despacho"
                        @click.prevent="getCompleteWaybill(data.item.waybill_id)"
                        class="fa fa-lg fa-search text-primary text-center"
                    ></a>
                </template>
                
                </b-table>
            </div> 

            <!-- verificar Proceso -->

            <div class="text-left" v-if="itemsProcess != ''">

                <h2>Proceso</h2>
                <b-table
                striped
                hover
                small
                :items="itemsProcess"
                :fields="fieldsProcess">

                <template v-slot:cell(Fecha_Proceso)="data">
                {{data.item.Fecha | moment}}
                </template>

                <template v-slot:cell(Proceso)="data">
                  <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeProcessDetail(data.item.process_id,data.item.Numero_Proceso,data.item.process_option)"
                        
                    >{{data.item.Numero_Proceso}}</a>
                
                </template>

                 <template v-slot:cell(Acciones)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Ver reporte de proceso"
                        @click.prevent="showProcessModal(data.item.process_id,data.item.process_option)"
                        class="fa fa-lg fa-search text-primary text-center"
                    ></a>
                    &nbsp;
                     <a
                        target="_blank"
                        href="#"
                        title="Ver si el pallet fue Repaletizado"
                        @click.prevent="checkRepalettingProcess(data.item)"
                        class="fa fa-lg fa-retweet text-primary text-center"
                    ></a>
                </template>
                
                </b-table>
            </div> 


            <div class="text-left" v-if="itemsDispatch != ''">

                <h2>Despacho</h2>
                <b-table
                striped
                hover
                small
                :items="itemsDispatch"
                :fields="fieldsDispatch">

               <template v-slot:cell(Fecha_Creacion)="data">
                {{data.item.Fecha | moment}}
                </template>

                <template v-slot:cell(Guia)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeGuiaDispatchDetail(data.item.waybill_id,data.item.Guia)"
                       
                    >{{data.item.Guia}}</a>
                </template>

                 <template v-slot:cell(Detalle)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Detalle"
                        @click.prevent="getCompleteWaybill(data.item.waybill_id)"
                        class="fa fa-lg fa-search text-primary text-center"
                    ></a>
                </template>
                
                </b-table>
            </div> 



              <div class="text-left" v-if="itemsBording != ''">

                <h2>Embarque</h2>
                <b-table
                striped
                hover
                small
                :items="itemsBording"
                :fields="fieldsBording">

      

               <template v-slot:cell(Fecha_Creacion)="data">
                {{data.item.Fecha | moment}}
                </template>

                <template v-slot:cell(Embarque)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seenPakingList(data.item.IDEmbarque,data.item.Embarque)"
                       
                    >{{data.item.Embarque}}</a>
                </template>

                 <template v-slot:cell(Detalle)="data">


                     <a target="_blank" href="#"
                     @click.prevent="downloadWithAxios(data.item.IDEmbarque, data.item.Embarque)"
                     class="fa fa-lg fa fa-list text-black-50" title="Packing List Embarque"></a>&nbsp;
                  <a target="_blank" href="#" @click.prevent="showBoardinInstructiveModal(data.item.IDEmbarque)"
                     class="fa fa-lg fa fa-plane text-black-50" title="Instructivo Embarque"></a>&nbsp;
                  <a target="_blank" href="#" @click.prevent="showExportInvoiceModal(data.item.IDEmbarque)"
                     class="fa fa-lg fa fa-usd text-black-50" title="Factura de Exportación"></a>&nbsp;
                   
                </template>
                
                </b-table>
            </div> 




            <div class="text-left" v-if="itemsDispatchExport != ''">

                <h2>Despacho Exportacion</h2>
                <b-table
                striped
                hover
                small
                :items="itemsDispatchExport"
                :fields="fieldsDispatchExport">

      

               <template v-slot:cell(Fecha_Creacion)="data">
                {{data.item.Fecha | moment}}
                </template>


                <template v-slot:cell(Guia)="data">
                    <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seenPakingListWaybillExport(data.item.waybill_id,data.item.Guia)"
                       
                    >{{data.item.Guia}}</a>
                </template>

                 <template v-slot:cell(Detalle)="data">

                    <a target="_blank" href="#"
                     @click.prevent="downloadWithAxiosWaybill(data.item.waybill_id, data.item.Guia)"
                     class="fa fa-lg fa fa-list text-black-50" title="Packing List Guia Despacho"></a>&nbsp;
                 
                </template>
                
                </b-table>
            </div> 
          </b-card>
        </b-col>
      </b-row>
    </div>

        <b-modal
            id="modal-lg"
            ref="infoModal"
            centered size="lg"
            title="Detalle de guia de despacho"
            @ok="waybill=null"
            ok-only
          >
            <div class="text-center">
              <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
            </div>
            <report v-if="waybill" :waybill="waybill"></report>
        </b-modal>

         <b-modal
          ref="infoModalProcess"
          centered size="xl"
          title="Reporte de proceso"
          @ok="closeModal"
          ok-only
        >
          <div class="text-center">
            <b-spinner v-if="loading" label="Spinning"></b-spinner>
          </div>
          
           <component :is="ReportProcess" :process="process" ref="ReportProcess"></component>
        </b-modal>

         <b-modal
          ref="infoModalRepa"
         centered size="xl"
          title="Reporte de repaletizaje"
          @ok="closeModal"
          ok-only
        >
        <div class="text-center">
            <b-spinner v-if="loading" label="Spinning"></b-spinner>
          </div>
         <component :is="componenteActual" :process="tableDataPalletIn" :tableDataMovimientos="tableDataMovimientos"  ref="ReportRepaletizaje"></component>
        </b-modal> 


          <b-modal

                v-model="modalShownBordingInstructive"
                centered size="lg"
                title="Instructivos de embarque"
                hide-footer
              >

                <component :is="componenteActualExport" :idBording="idBording" :shipment="shipment" :ref="reportShipment"></component>


              </b-modal>



  </div>

</template>



<script>

import moment from 'moment'
import Report from '../recepcion/Report.vue'
import ReportProcess from '../procesos/Report2.vue'
import ReportRepaletizaje from '../procesos/ImprimirRepaletizaje.vue'

import ReportInstructivoEmbarqueMaritimo from '../exportacion/ReportInstructivoEmbarqueMaritimo.vue'
import ReportInstructivoEmbarqueAereo from '../exportacion/ReportInstructivoEmbarqueAereo.vue'
import ReportFacturaExportacion from '../exportacion/ReportFacturaExportacion.vue'

import miniToastr from 'mini-toastr'

 const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

 

export default {
  name: 'DetalleTrazabilidad',
  props:['PalletID','ContentID','PalletNumber'],
  components: {
      Report,
      ReportProcess,
      ReportRepaletizaje,
      ReportInstructivoEmbarqueMaritimo,
      ReportInstructivoEmbarqueAereo,
      ReportFacturaExportacion
    },
  created () {
  },
  data () {
    return {
     fieldsReception: ['Fecha_Creacion', 'Guia','Acciones'],
     itemsReception: [],
     waybill: null,
     fieldsProcess: ['Tipo_Proceso','Fecha_Proceso', 'Proceso','Actividad','Acciones'],
     itemsProcess: [],
     process: [],
     tableDataPalletIn: [],
     tableDataMovimientos:[],
     loading: false,
     componenteActual: '',
     itemsDispatch:[],
     fieldsDispatch: ['Fecha_Creacion', 'Guia','Detalle'],
     itemsDispatchExport:[],
     fieldsDispatchExport: ['Fecha_Creacion', 'Guia','Detalle'],
     componenteActualExport: '',
     idBording: 0,
     shipment: '',
     reportShipment: '',
     modalShownBordingInstructive:false,
     itemsBording:[],
     fieldsBording: ['Fecha_Creacion', 'Embarque','Detalle'],
    
    }
  },
  filters: {
      moment(value) {
        return moment(value).format('DD-MM-YYYY HH:MM')
      }
    },
    methods: {
        getCompleteWaybill(a) {
           this.$refs.infoModal.show()
           this.$axios.get ('/api/v1/waybill/'+a+'/waybill_complete/')
          .then(res => {
            this.waybill = res.data
          })
          .catch(error => console.log(error)) 
        },
        checkReception(){
          this.$axios.get('/api/v1/content/check_reception_content/', {
          params: {
          id: this.ContentID,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
            this.itemsReception=[];
            const datos = res.data.data;
               for (let key in datos) {
                var rowNew = {
                  Fecha: datos[key].created_at,
                  Guia: datos[key].waybill_number,
                  waybill_id: datos[key].waybill,
                };
                this.itemsReception.push(rowNew);
               }
        })
       .catch(error => {
          console.log(error.response)
        });
        },
         checkProcess(){
          this.$axios.get('/api/v1/content/check_entry_process_content/', {
          params: {
          id: this.ContentID,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
            this.itemsProcess=[];
            const datos = res.data.data;
                 for (let key in datos) {
                var rowNew = {
                  process_option : datos[key].process.process_type.process_option,
                  Tipo_Proceso: datos[key].process.process_type.name,
                  Fecha: datos[key].process.start_time,
                  Numero_Proceso: datos[key].process.number,
                  process_id: datos[key].process.id,
                  IDContenido: datos[key].content.id,
                  Actividad: datos[key].content_type == 2 ? "Ingreso a proceso" : "Creado en proceso",
                };
                this.itemsProcess.push(rowNew);
               } 
        })
       .catch(error => {
          console.log(error.response)
        });
        },
         checkDispatch(){
          this.$axios.get('/api/v1/content/check_dispatch_content/', {
          params: {
          id: this.ContentID,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
            this.itemsDispatch=[];
            const datos = res.data.data;
               for (let key in datos) {
                var rowNew = {
                  Fecha: datos[key].pallet.dispatch_waybill_created,
                  Guia: datos[key].pallet.dispatch_waybill_number,
                  waybill_id: datos[key].pallet.dispatch_waybill_id,
                };
                this.itemsDispatch.push(rowNew);
               }
        })
       .catch(error => {
          console.log(error.response)
        });
        },
         checkExport(){
          this.$axios.get('/api/v1/content/check_export_content/', {
          params: {
          id: this.ContentID,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
        
            this.itemsDispatchExport=[];

            const datos = res.data.data;

               for (let key in datos) {

                var rowNew = {
                  Fecha: datos[key].pallet.dispatch_waybill_created,
                  Guia: datos[key].pallet.dispatch_waybill_number,
                  waybill_id: datos[key].pallet.dispatch_waybill_id,
                  Numero_Factura: datos[key].pallet.shipment.invoice_number,
                };

                this.itemsDispatchExport.push(rowNew);
               }

        })
       .catch(error => {
          console.log(error.response)
        });
        },
        getProcess (process_id) {
          this.$axios.get ('/api/v1/process/'+process_id+'/detailed_with_traceability/')
          .then(res => {
            this.process = res.data;
            this.loading = false;
          })
          .catch(error => console.log(error))
        },
         getProcessRepa (process_id) {
        
          this.tableDataPalletIn=[];
           this.tableDataMovimientos=[];

          this.$axios.get ('/api/v1/process/'+process_id+'/process_detail_repaletizaje/')
          .then(res => {
              this.tableDataPalletIn = res.data.movement_content;
              this.loading = false;

            const datos = res.data.movement_content;


            for (let key in datos) {

              var rowNew = {
                Pallet_entrada: datos[key].content.pallet_number,
                Pallet_salida: datos[key].content_reference.pallet_number,
                Producto: datos[key].content.product_name,
                Tipo_producto: datos[key].content.product_type_name,
                Variedad: datos[key].content.variety_name,
                origin: datos[key].content_reference.origin_name,
                kilos_brutos: datos[key].content.gross_kilograms,
                kilos_netos: datos[key].content.net_kilograms,
                Cantidad: datos[key].content.quantity,
                IDContenido: datos[key].content.id,
                container: datos[key].content_reference.container.name,
                condition: datos[key].content_reference.condition,
                variety: datos[key].content_reference.variety_name,
                creation_date: datos[key].content_reference.creation_date,
                plant: datos[key].content_reference.plant,

              };

              this.tableDataMovimientos.push(rowNew);
            }
          })
          .catch(error => console.log(error.message))
        },
         showProcessModal(a,typeProcess) {

        if(typeProcess==1){

          this.ReportProcess = 'ReportProcess';
          this.loading = true;
          this.$nextTick(function () {
              this.getProcess(a);
            })

            this.$refs.infoModalProcess.show()

        }

         if(typeProcess==2){

          this.componenteActual='ReportRepaletizaje';
          this.loading = true;
          this.$nextTick(function () {
            this.getProcessRepa(a);
            })

            this.$refs.infoModalRepa.show();
        }

        
        

      },
       closeModal () {
          this.$refs.report.process = [];
          this.process = [];
          this.ReportProcess = '';
        },
        checkRepalettingProcess(row){

          if(row.process_option==1){

             this.$router.push("/trazabilidad/process-repaletting/"+row.process_id+"/"+row.IDContenido+"/"+this.PalletNumber);

          }


          if(row.process_option==2){

            miniToastr.info("Sin Informacion", "");

          }

        },
         goBack(){
             this.$router.go(-1)
         },
         forceFileDownload(response, a) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Packing List - Embarque #' + a + '.xlsx') //or any other extension
            document.body.appendChild(link)
            link.click()
          },
         downloadWithAxios(a, b) {
              this.$axios({
                method: 'get',
                url: '/api/comex/shipment/' + a + '/packing_list/',
                responseType: 'arraybuffer'
              })
                .then(response => {

                  this.forceFileDownload(response, b)
                  miniToastr.success("Packing list generado con éxito.", "Packing List:");

                })
                .catch((error) => {
                  miniToastr.error("Problemas al generar packing list", "Error:");
                  console.log(error)
                });
         },
          showBoardinInstructiveModal(a) {
        this.$axios({
          method: 'get',
          url: '/api/comex/shipment/' + a + '/detailed_shipment/',
        })
          .then(response => {
            a = response.data
            //es maritimo
            if (a.shipment_type.id == 1) {

              this.modalShownBordingInstructive = true;
              this.idBording = a.id;
              this.shipment = a;
              this.componenteActualExport = 'ReportInstructivoEmbarqueMaritimo';


              this.reportShipment = 'reportShipment';
              this.$nextTick(function () {
                this.$refs.reportShipment.calcular();
              })


            }

            //es aereo
            if (a.shipment_type.id == 2) {

              this.modalShownBordingInstructive = true;
              this.idBording = a.id;
              this.shipment = a;
              this.componenteActualExport = 'ReportInstructivoEmbarqueAereo';


              this.reportShipment = 'reportShipment';
              this.$nextTick(function () {
                this.$refs.reportShipment.calcular();
              })


            }
          })
          .catch((error) => {
            console.log(error)
          });


      },
      showExportInvoiceModal(a) {

        this.$axios({
          method: 'get',
          url: '/api/comex/shipment/' + a + '/detailed_shipment/',
        })
          .then(response => {
            a = response.data
            this.modalShownBordingInstructive = true;
            this.idBording = a.id;
            this.shipment = a;
            this.componenteActualExport = 'ReportFacturaExportacion';

            this.reportShipment = 'reportShipment';
            this.$nextTick(function () {
              this.$refs.reportShipment.calcular();
            })
          })
          .catch((error) => {
            console.log(error)
          });


      },
      forceFileDownloadWaybill(response, a) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Packing List - Guia #' + a + '.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
      },
       downloadWithAxiosWaybill(a, b) {
        this.$axios({
          method: 'get',
          url: '/api/comex/export_waybill/' + a + '/packing_list/',
          responseType: 'arraybuffer'
        })
          .then(response => {

            this.forceFileDownloadWaybill(response, b)

          })
          .catch(() => console.log('error occured'))
      },
      checkBording(){
          this.$axios.get('/api/v1/content/check_bording_content/', {
          params: {
          id: this.ContentID,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
        
            this.itemsBording=[];

            const datos = res.data.data;

               for (let key in datos) {

                 if(datos[key].pallet.shipment.id === undefined){


                 }else{

                   var rowNew = {
                  Fecha: datos[key].pallet.shipment.created_at,
                  Embarque:datos[key].pallet.shipment.boarding_number,
                  IDEmbarque:datos[key].pallet.shipment.id,
                  Numero_Factura: datos[key].pallet.shipment.invoice_number,
                };

                this.itemsBording.push(rowNew);



                 }
                


               }

        })
       .catch(error => {
          console.log(error.response)
        });
        },
        seeGuideDetail(waybill_id,numGuia)
        {
    
            this.$router.push("/trazabilidad/detailed-waybill-reception/"+waybill_id+"/"+numGuia);
        },
         seeProcessDetail(process_id,numProcess,tipoProceso)
        {

          if(tipoProceso==1){

             this.$router.push("/trazabilidad/detailed-process/"+process_id+"/"+numProcess);

          }

          if(tipoProceso==2){

             this.$router.push("/trazabilidad/detailed-repaletizaje/"+process_id+"/"+numProcess);

          }
   
           
        },
         seeGuiaDispatchDetail(waybill_id,numGuia)
        {
            this.$router.push("/trazabilidad/detailed-waybill-dispatch/"+waybill_id+"/"+numGuia);
        },
        seenPakingList(bording_id,numEmbarque)
        {
            this.$router.push("/trazabilidad/detailed-bording/"+bording_id+"/"+numEmbarque);
        },
        seenPakingListWaybillExport(waybill_id,numWaybill)
        {
            this.$router.push("/trazabilidad/detailed-waybill-export/"+waybill_id+"/"+numWaybill);
        },
        },
      mounted(){
            this.checkReception();
            this.checkProcess();
            this.checkDispatch();
            this.checkBording();
            this.checkExport();

      }
}

</script>
